// extracted by mini-css-extract-plugin
export default {"container":"dat_1Z007","withBorder":"dat_wit_PuxiE"};